import * as React from "react";
import { Input } from "@/components/ui/input";
import { LucideIcon } from "lucide-react";

interface IconInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon: LucideIcon;
}

const IconInput = React.forwardRef<HTMLInputElement, IconInputProps>(
  ({ icon: Icon, className = "", ...props }, ref) => {
    return (
      <div className="relative">
        <Icon className="absolute left-3 top-3 h-4 w-4 text-muted-foreground pointer-events-none" />
        <Input ref={ref} className={`pl-9 ${className}`} {...props} />
      </div>
    );
  }
);

IconInput.displayName = "IconInput";

export default IconInput;